import React, { useState } from "react";
import Progress from "./Progress";
import Question from "./Question";
import Answers from "./Answers";
import MoreContact from "./MoreContact";

import data from "./data/quiz.json";

import {
  BackgroundStart,
  BackgroundNext,
  BtnStart,
  BtnNext,
  Match,
  NoMatch,
  Error,
} from "./StyledComponents/Contact.style";

import ImgToStart from "./asset/pictures/Backgrounds/SVG/05.svg";

const Quiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentAnswer, setCurrentAnswer] = useState("");
  const [answers, setAnswers] = useState([]);
  const [showResults, setShowresults] = useState(false);
  const [error, setError] = useState("");
  const [mark, setMark] = useState(0);
  const [start, setStart] = useState(true);

  const quizList = data.quiz;

  const question = quizList[currentQuestion].question;

  const questionId = quizList[currentQuestion].id;
  const answersList = quizList[currentQuestion];

  const handleClick = (e) => {
    const targetValue = e.target.value;
    setCurrentAnswer(targetValue);
    setError("");
  };

  const renderError = () => {
    if (!error) {
      return;
    }
    return <Error>{error}</Error>;
  };
  const resart = () => {
    setAnswers([]);
    setCurrentAnswer("");
    setCurrentQuestion(0);
    setShowresults(false);
    setMark(0);
  };
  const next = () => {
    currentAnswer === answersList.correct_answer
      ? setMark(mark + 20)
      : setMark(mark + 0);

    const answer = {
      questionId: questionId,
      answer: { currentAnswer },
    };

    if (!currentAnswer) {
      setError("Choisir une réponse");
      return;
    }
    answers.push(answer);
    setAnswers(answers);
    setCurrentAnswer("");

    if (currentQuestion + 1 < quizList.length) {
      setCurrentQuestion(currentQuestion + 1);
      return;
    }
    setShowresults(true);
  };
  const startQuiz = () => {
    return setStart(!start);
  };
  if (showResults) {
    return (
      <>
        {mark <= 50 ? (
          <NoMatch>
            <h2> Alors, est-ce qu'on est fait pour bosser ensemble ?!</h2>
            <p>match à {mark}%</p>
            <BtnNext backgroundColor="#363f59" onClick={resart}>
              Recommencer
            </BtnNext>
          </NoMatch>
        ) : (
          <Match>
            <h2> Alors, est-ce qu'on est fait pour bosser ensemble ?!</h2>
            <p>match à {mark}%</p>
            <MoreContact />
          </Match>
        )}
      </>
    );
  } else {
    return (
      <>
        {start ? (
          <BackgroundStart>
            <img src={ImgToStart} alt="background for start" />
            <BtnStart onClick={startQuiz}>Start</BtnStart>
          </BackgroundStart>
        ) : (
          <BackgroundNext>
            <Progress
              totalQuestions={quizList.length}
              currentQuestion={currentQuestion + 1}
            />
            <Question question={question} />
            {renderError()}
            <Answers
              answers={answersList}
              handleClick={handleClick}
              currentAnswer={currentAnswer}
            />
            <BtnNext onClick={next}>Next</BtnNext>
          </BackgroundNext>
        )}
      </>
    );
  }
};
export default Quiz;
